interface DashboardHeaderProps {
  title?: string;
  description?: string;
}

export function DashboardHeader({
  title = 'Dashboard',
  description = 'Activity overview and pending tasks (Live Updates Enabled)',
}: DashboardHeaderProps) {
  return (
    <div>
      <h1 className="text-2xl font-bold text-foreground">{title}</h1>
      <p className="text-muted-foreground">{description}</p>
    </div>
  );
}
